import { useState, useEffect, useCallback } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Segment } from 'semantic-ui-react';
import { CustomSegment } from '../../../../components';
import { putActivity } from '../../../../store/actions';
import { get } from '../../../../utils/lodash';
import { HtmlService } from '../../../../services';
import {
  CKField,
  IncludeInReportToggle,
  saveReportInclusion,
} from '../reportFields';
import '../activity.scss';

function EvaluationMethodology({
  t,
  currentActivity,
  putActivity,
  pageDisabled,
}) {
  const parseInclusions = (raw) => {
    try {
      return JSON.parse(raw || '{}');
    } catch {
      return {};
    }
  };
  const [inclusions, setInclusions] = useState(() =>
    parseInclusions(currentActivity.reportInclusions)
  );

  useEffect(() => {
    setInclusions(parseInclusions(currentActivity.reportInclusions));
  }, [currentActivity.id]); // eslint-disable-line react-hooks/exhaustive-deps

  // Wrap putActivity to also broadcast when methodology is saved from this
  // side — ActivitySteps' central BroadcastChannel listener picks this up
  // and merges it into Redux, keeping the Report Builder preview in sync
  // regardless of which step is active.
  const handlePutActivity = (type, data) => {
    putActivity(type, data);
    if (data.evaluationMethodology !== undefined) {
      const ch = new BroadcastChannel('takso_activity');
      ch.postMessage({
        type: 'methodology',
        activityId: currentActivity.id,
        evaluationMethodology: data.evaluationMethodology,
      });
      ch.close();
    }
  };

  const handleInclusionToggle = useCallback(
    async (key, value) => {
      setInclusions((prev) => ({ ...prev, [key]: value }));
      const merged = await saveReportInclusion({
        activityId: currentActivity.id,
        key,
        value,
      });
      if (merged) {
        setInclusions(merged);
      }
    },
    [currentActivity.id]
  );

  return (
    <CustomSegment
      className="evaluation-methodology-seg"
      title={t('activity.evaluation_methodology.title')}
      rightHeader={
        <IncludeInReportToggle
          included={inclusions.methodology !== false}
          onToggle={(v) => handleInclusionToggle('methodology', v)}
          disabled={pageDisabled}
        />
      }
      extraMargin
      disabled={pageDisabled}
      children={
        <Segment className="document-note-seg" disabled={pageDisabled}>
          <div className="document-note-div">
            <CKField
              key={`methodology-${currentActivity.id}-${
                get(currentActivity, 'evaluationMethodology', '') || ''
              }`}
              placeholder={t('activity.evaluation_methodology.placeholder')}
              initialData={HtmlService.convertToInnerHtml({
                children:
                  get(currentActivity, 'evaluationMethodology', '') || '',
                richText: true,
                htmlConversionStyle: 'para',
              })}
              fieldName="evaluationMethodology"
              putActivity={handlePutActivity}
              disabled={pageDisabled}
            />
          </div>
        </Segment>
      }
    />
  );
}

const mapStateToProps = (state) => ({
  ...state.activity,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ putActivity }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(EvaluationMethodology));
